import { Form, Formik } from 'formik';
import { useState } from 'react';
import { Modal } from 'app/shared/components/modals/Modal';
import { IFilesData, IUploadFilesModalProps } from '../interfaces';
import { uploadFileValidationSchema } from '../validation';
import { UploadFilesForm } from './UploadFilesForm';


export const UploadFilesModal = ({
  uploadFilesModalPosition,
  handleClose,
  handleSubmit,
  dealId,
  assetOptions,
  assetId
}: IUploadFilesModalProps) => {

  const initValues: IFilesData = {
    files: [],
    docs: [],
    assetId:  assetId || '',
  };

  const [isValid, setIsValid] = useState(false);

  return (
    <Modal
      hideBackdrop
      title="Upload Files"
      open={!!uploadFilesModalPosition}
      resetPosition={uploadFilesModalPosition}
      dialogWidth={'1000px'}
      onClose={handleClose}
    >
      <Formik
        enableReinitialize
        initialValues={initValues}
        validationSchema={() => uploadFileValidationSchema(isValid)}
        onSubmit={handleSubmit}
      >
        {(props) => (
          <Form>
            <UploadFilesForm
              dealId={dealId}
              assetOptions={assetOptions}
              setIsValid={setIsValid}
              setFieldValue={props.setFieldValue}
              value={props.values}
            />
          </Form>
        )}
      </Formik>
    </Modal>
  );
};
